import { $translate } from '@/utils/i18n';
export default {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        clickState: true,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: $translate('lang.E3202103220015', { defaultText: '企业名称' }),
                align: 'center',
                prop: 'tenantName',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220016', { defaultText: '企业前缀' }),
                align: 'center',
                prop: 'tenantCode',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220012', { defaultText: '用户名' }),
                align: 'center',
                prop: 'userCode',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220017', { defaultText: '日志详情' }),
                align: 'center',
                prop: 'remark',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220018', { defaultText: '操作IP地址' }),
                align: 'center',
                prop: 'remoteIP',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220019', { defaultText: '操作浏览器类型' }),
                align: 'center',
                prop: 'broswer',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220013', { defaultText: '操作时间' }),
                align: 'center',
                prop: 'createTime',
                filter: true,
                require: true,
                width: 100
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
